import React from "react";
import { useTranslation } from "react-i18next";

import useMaterialsByCode from "fe-shared/src/hooks/useMaterialsByCode";

import { Transaction, Transfer } from "../../types";

import styles from "./AttributesInfo.module.scss";

export interface Props {
  transactionOrTransfer: Transaction | Transfer;
}

export const AttributesInfo = ({ transactionOrTransfer }: Props) => {
  const { t } = useTranslation();
  const materialsByCode = useMaterialsByCode();
  const { materialAttributes } = transactionOrTransfer;

  return materialAttributes.length ? (
    <div className={styles.attributesInfo}>
      <span>{t("transactions.details.otherStuff")}</span>
      <p>
        {materialAttributes.map((ma) => materialsByCode[ma]?.name).join(", ")}
      </p>
    </div>
  ) : null;
};

export default AttributesInfo;
